import { render } from "./Columns.vue?vue&type=template&id=e13cd0d8&scoped=true"
import script from "./Columns.vue?vue&type=script&lang=js"
export * from "./Columns.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-e13cd0d8"

export default script